import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';

import { AuthProvider } from 'contexts/AuthContext';
import { DebugProvider } from 'contexts/DebugContext';
import { TimezoneProvider } from 'contexts/TimezoneContext';
import { ToastProvider } from 'components/ui/use-toast';
import { AppRoutes } from './routes/AppRoutes';
import { PerformanceTracking } from 'components/PerformanceTracking';
import { MobileRuntime } from 'mobile/MobileRuntime';
import { MobilePushTokenSync } from 'mobile/MobilePushTokenSync';
import { NativeLaunchScreenRelease } from 'mobile/NativeLaunchScreenRelease';
import { NativePullToRefresh } from 'mobile/NativePullToRefresh';

function App() {
  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <AuthProvider>
        <MobileRuntime />
        <NativeLaunchScreenRelease />
        <NativePullToRefresh />
        <MobilePushTokenSync />
        <PerformanceTracking />
        <DebugProvider>
          <TimezoneProvider>
            <ToastProvider>
              <AppRoutes />
            </ToastProvider>
          </TimezoneProvider>
        </DebugProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;














